import React, { useState, useEffect } from "react";
import { useUpdateData } from "hooks/useApiHooks";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import BookingDetailsComponent from "../booking-details";

const UpdateKomisi = ({ booking, onSuccess, onError }) => {
  console.log("Booking Data:", booking);
  const isValidBooking = !!booking?.id;

  // State untuk menyimpan data form
  const [formData, setFormData] = useState({
    total_price: 0, // 🔹 Total berdasarkan activity yang dichecklist
    total_income: 0,
    susuk_agent: 0, // 🔹 Hasil perhitungan otomatis
    status_susuk_agent: "hold",
    note_susuk: "",
  });

  const [selectedActivities, setSelectedActivities] = useState({});
  const [includeSusuk, setIncludeSusuk] = useState([]);
  const [formError, setFormError] = useState(null);

  // Hook API untuk update data
  const API_URL = `/reservation/${booking?.id}/susuk-agent`;
  const { updateData, loading: updating } = useUpdateData(API_URL, "komisi");
  const { handleSubmit, isSubmitting } = useSubmitHandler(
    updateData,
    onSuccess,
    onError
  );

  // 📌 **Load data dari API dan set aktivitas yang sudah include_susuk**
  useEffect(() => {
    if (booking?.activities) {
      const defaultSelected = {};
      const defaultIncludeSusuk = [];

      booking.activities.forEach((activity) => {
        const isIncluded = activity.include_susuk === 1;
        defaultSelected[activity.id] = isIncluded;
        if (isIncluded) {
          defaultIncludeSusuk.push(activity.id);
        }
      });

      setSelectedActivities(defaultSelected);
      setIncludeSusuk(defaultIncludeSusuk);
    }
  }, [booking]);

  // 📌 **Hitung total price hanya dari aktivitas yang dichecklist**
  useEffect(() => {
    if (booking?.activities) {
      const selectedTotal = booking.activities
        .filter((activity) => selectedActivities[activity.id]) // Hanya yang dichecklist
        .reduce(
          (acc, activity) => acc + activity.qty * parseFloat(activity.price),
          0
        );

      setFormData((prevData) => ({
        ...prevData,
        total_price: selectedTotal,
      }));
    }
  }, [selectedActivities, booking]);

  // 📌 **Update include_susuk saat user checklist/uncheck activity**
  useEffect(() => {
    const selectedIds = Object.keys(selectedActivities)
      .filter((id) => selectedActivities[id])
      .map(String);

    setIncludeSusuk(selectedIds);
    console.log("🔍 include_susuk saat ini:", selectedIds);
  }, [selectedActivities]);

  // 📌 **Hitung ulang `susuk_agent` setiap kali `total_price` atau `total_income` berubah**
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      susuk_agent: prevData.total_price - prevData.total_income,
    }));
  }, [formData.total_price, formData.total_income]);

  useEffect(() => {
    if (booking?.net_price_by_include_susuk) {
      setFormData((prevData) => ({
        ...prevData,
        total_income: booking.net_price_by_include_susuk, // Ambil nilai awal
        note_susuk: booking.note_susuk || "", // Ambil note_susuk jika ada
      }));
    }
  }, [booking]);

  const handleNumericChange = (e) => {
    const { name, value } = e.target;

    // Hilangkan karakter selain angka
    const numericValue = value.replace(/\D/g, "");

    // Simpan angka mentah di state
    setFormData((prevData) => ({
      ...prevData,
      [name]: numericValue, // Simpan sebagai angka tanpa format
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "total_income") {
      const numericValue = parseInt(value.replace(/\./g, ""), 10) || 0;

      if (numericValue > formData.total_price) {
        setFormError(
          "Total pemasukan tidak boleh lebih besar dari total penjualan."
        );
      } else {
        setFormError(null);
      }

      setFormData((prevData) => ({
        ...prevData,
        total_income: numericValue,
      }));
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  const handleBeforeSubmit = (e) => {
    e.preventDefault();

    // if (formData.total_income > formData.total_price) {
    //   setFormError(
    //     "Total pemasukan tidak boleh lebih besar dari total penjualan."
    //   );
    //   return;
    // }

    const payload = {
      ...formData,
      susuk_agent: formData.susuk_agent, // 🔹 Hasil perhitungan
      include_susuk: includeSusuk, // 🔹 Hanya aktivitas yang dichecklist
    };

    console.log("🚀 Payload yang dikirim ke API:", payload);
    handleSubmit(payload, e);
  };

  if (!isValidBooking) {
    return (
      <p className="text-danger">Error: Tidak ada data booking untuk update.</p>
    );
  }

  return (
    <form onSubmit={handleBeforeSubmit} className="d-flex flex-column">
      <AgentDetail agent={booking.agent} formatPrice={formatPrice} />
      {/* <p>ID Booking: {booking.id}</p> */}
      {/* <BookingDetail booking={booking} /> */}
      <BookingDetailsComponent booking={booking} />

      {/* Aktivitas */}

      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <h5 className="card-title">Activities</h5>
          {booking.activities && booking.activities.length > 0 ? (
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Select</th>
                  <th>Activity</th>
                  <th>Type</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {booking.activities.map((activity, index) => (
                  <tr key={activity.id}>
                    <td>{index + 1}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!selectedActivities[activity.id]}
                        onChange={() =>
                          setSelectedActivities((prev) => ({
                            ...prev,
                            [activity.id]: !prev[activity.id],
                          }))
                        }
                      />
                    </td>
                    <td>{activity.activity}</td>
                    <td>{activity.type}</td>
                    <td>{activity.qty}</td>
                    <td>{formatPrice(activity.price)}</td>
                    <td>{formatPrice(activity.qty * activity.price)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-muted">No activities available.</p>
          )}
        </div>
      </div>

      {/* Total Penjualan */}
      <div className="row mb-3 align-items-center">
        <label className="col-sm-4 col-form-label text-end fw-bold">
          Total Penjualan:
        </label>
        <div className="col-sm-8">
          <input
            type="text"
            className="form-control"
            value={formatPrice(formData.total_price)}
            disabled
          />
        </div>
      </div>

      {/* Total Pemasukan */}
      <div className="row mb-3 align-items-center">
        <label className="col-sm-4 col-form-label text-end fw-bold">
          Total Pemasukan Kotor:
        </label>
        <div className="col-sm-8">
          {/* <input
            type="text"
            className="form-control"
            name="total_income"
            value={formatPrice(formData.total_income)}
            onChange={handleChange}
          /> */}
          <input
            type="text"
            className="form-control"
            name="total_income"
            value={new Intl.NumberFormat("id-ID").format(formData.total_income)} // Format tampilan
            onChange={handleNumericChange}
          />

          {formError && <small className="text-danger">{formError}</small>}
        </div>
      </div>

      {/* Susuk Agent */}
      <div className="row mb-3 align-items-center">
        <label className="col-sm-4 col-form-label text-end fw-bold">
          Susuk Agent:
        </label>
        <div className="col-sm-8">
          <input
            type="text"
            className="form-control"
            value={formatPrice(formData.susuk_agent)}
            disabled
          />
        </div>
      </div>

      {/* note_susuk */}
      <div className="row mb-3 align-items-center">
        <label className="col-sm-4 col-form-label text-end fw-bold">
          Note Susuk:
        </label>
        <div className="col-sm-8">
          <textarea
            className="form-control"
            name="note_susuk"
            value={formData.note_susuk}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                note_susuk: e.target.value,
              }))
            }
            rows="3"
          ></textarea>
        </div>
      </div>

      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Updating..." : "Update Komisi"}
        </button>
      </div>
    </form>
  );
};

export default UpdateKomisi;

// aget detail
const AgentDetail = ({ agent, formatPrice }) => {
  return (
    <div className="card shadow-sm border-0">
      <div className="card-body">
        <h5 className="card-title">Agent Detail</h5>
        <table className="table table-sm table-striped table-bordered">
          <tbody>
            <tr>
              <td>Agent Name</td>
              <td>{agent?.name}</td>
            </tr>
            <tr>
              <td>Agent Email</td>
              <td>{agent?.email}</td>
            </tr>
            <tr>
              <td>Agent Phone</td>
              <td>{agent?.phone}</td>
            </tr>
            <tr>
              <td>Agent Activity Name & Price</td>
              <td>
                {agent?.products?.map((activity, index) => (
                  <li key={index}>
                    {activity.name} - Rp.{" "}
                    {formatPrice(activity.pivot.price_agent)}
                  </li>
                ))}
              </td>
            </tr>
          </tbody>
        </table>
        {/* print json agent */}
        {/* <pre>{JSON.stringify(agent, null, 2)}</pre> */}
      </div>
    </div>
  );
};

// booking detail
const BookingDetail = ({ booking }) => {
  return (
    <div className="card shadow-sm border-0">
      <div className="card-body">
        <h5 className="card-title">Booking Detail</h5>
        <table className="table table-sm table-striped table-bordered">
          <tbody>
            <tr>
              <td>Booking Code</td>
              <td>{booking.code}</td>
            </tr>
            <tr>
              <td>Booking Date</td>
              <td>{booking.reservation_date}</td>
            </tr>
            <tr>
              <td>Booking Status</td>
              <td>{booking.status}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
